export interface Point {
    x: number,
    y: number
}

// https://code-log.hatenablog.com/entry/2019/08/31/111451

function drawLines(points: Array<Point>, context: CanvasRenderingContext2D, lineClosed: boolean) {
    let first = points[0];
    context.moveTo(first.x, first.y);
    for (var i = 1; i < points.length; i++) {
        context.lineTo(points[i].x, points[i].y);
    }
    if (lineClosed) {
        context.lineTo(first.x, first.y);
    }
}

function drawLine(from: Point, to: Point, context: CanvasRenderingContext2D) {
    context.moveTo(from.x, from.y);
    context.lineTo(to.x, to.y);
}

function moveTo(point: Point, context: CanvasRenderingContext2D) {
    context.moveTo(point.x, point.y);
}

function lineTo(point: Point, context: CanvasRenderingContext2D) {
    context.lineTo(point.x, point.y);
}

function setStrokeStyle(strokeStyle: string | CanvasGradient | CanvasPattern, context: CanvasRenderingContext2D) {
    context.strokeStyle = strokeStyle;
}

function fillText(text: string, leftTop: Point, context: CanvasRenderingContext2D) {
    context.fillText(text, leftTop.x, leftTop.y);
}

export default {
    drawLines: drawLines,
    drawLine: drawLine,
    moveTo: moveTo,
    lineTo: lineTo,
    setStrokeStyle: setStrokeStyle,
    fillText: fillText,
};
